import { HUESO, SANGRE } from '../ui/HudCombat.js';

import { worldToScreen, type IsoTileSize } from './iso.js';

import type Phaser from 'phaser';

/**
 * "Damage numbers" flotantes (TKT-029).
 *
 * Cap de 10 simultáneos para no saturar (AC del ticket). Duración 800 ms;
 * desliza 32 px hacia arriba y se desvanece.
 */

const DURATION_MS = 800;
const RISE_PX = 32;
const MAX_ACTIVE = 10;

interface ActiveNumber {
  text: Phaser.GameObjects.Text;
  startMs: number;
  baseX: number;
  baseY: number;
}

export class DamageNumberLayer {
  private scene: Phaser.Scene;
  private tile: IsoTileSize;
  private active: ActiveNumber[] = [];
  private now: () => number;

  constructor(scene: Phaser.Scene, tile: IsoTileSize, now: () => number = () => performance.now()) {
    this.scene = scene;
    this.tile = tile;
    this.now = now;
  }

  spawn(world: { x: number; y: number }, amount: number, isCrit: boolean): void {
    if (this.active.length >= MAX_ACTIVE) {
      const oldest = this.active.shift();
      oldest?.text.destroy();
    }
    const screen = worldToScreen(world, this.tile);
    const txt = this.scene.add.text(screen.x, screen.y - 20, `${amount}`, {
      fontFamily: 'ui-monospace, monospace',
      fontSize: isCrit ? '24px' : '18px',
      color: isCrit ? SANGRE : HUESO,
      stroke: '#0b0b0f',
      strokeThickness: 3,
    });
    txt.setOrigin(0.5);
    txt.setDepth(10);
    this.active.push({ text: txt, startMs: this.now(), baseX: screen.x, baseY: screen.y - 20 });
  }

  update(): void {
    const now = this.now();
    for (let i = this.active.length - 1; i >= 0; i--) {
      const n = this.active[i]!;
      const t = (now - n.startMs) / DURATION_MS;
      if (t >= 1) {
        n.text.destroy();
        this.active.splice(i, 1);
        continue;
      }
      n.text.setPosition(n.baseX, n.baseY - RISE_PX * t);
      n.text.setAlpha(1 - t);
    }
  }

  clear(): void {
    for (const n of this.active) n.text.destroy();
    this.active.length = 0;
  }
}

export { DURATION_MS, MAX_ACTIVE };
